import { GivelifyLabel } from '@givelify/givelify-ui';
import { styled } from '@mui/material';

export const ModalContainer = styled('div')(({ theme }) => ({
    textAlign: 'center',
    padding: theme.spacing(0, 5),
    [theme.breakpoints.down('mobile')]: {
        padding: theme.spacing(0, 2),
    },
    '& input': {
        background: '#fff',
        borderColor: '#adadad',
        padding: theme.spacing(2),
    },
}));

export const ConfirmationText = styled(GivelifyLabel)({
    marginTop: 46,
    marginBottom: 32,
});

export const Description = styled(GivelifyLabel)({
    marginBottom: 92,
});
